import request from '../utils/request';
//获取职业培训的详情
export function toZyPxClassDetail(data) {
  return request({
    url: '/wap/class/toZyPxClassDetail.html',
    method: 'post',
    data
  })
}
//搜索数据
export function toClassDetailByPx(data) {
  return request({
    url: '/class/toClassDetailByPx.html',
    method: 'post',
    data
  })
}
export function toClassIsBuy(data) {
  return request({
    url: '/class/toClassIsBuy.do',
    method: 'post',
    data
  })
}
export function toGeneratePxOrder(data) {
  return request({
    url: '/wap/tyOrder/toGenerateOrder.do',
    method: 'post',
    data
  })
}




